import { reapitConnectBrowserSession } from '@reapit-sales/reapit-connect'
import { UserIdentificationUtility } from '@reapit-sales/utilities'
import { useReapitConnect } from '@reapit/connect-session'
import { useQueryClient } from '@tanstack/react-query'
import { LAST_LOGOUT_TIMESTAMP_KEY } from '@crm/constants'
import { currentTabOrganisationId } from '@reapit-sales/api-v3'

export const useHandleLogout = () => {
  const queryClient = useQueryClient()
  const { connectLogoutRedirect } = useReapitConnect(reapitConnectBrowserSession)

  const handleLogout = () => {
    // Clear user identity for Mixpanel tracking and Sentry error reporting
    UserIdentificationUtility.clearUserIdentity()

    // Clear React Query cache
    queryClient.clear()

    // Redirect to the logout page
    connectLogoutRedirect()

    // Clear session storage for the current tab's organisation ID
    // This is to ensure that the current tab does not retain any organisation ID after logout
    sessionStorage.removeItem(currentTabOrganisationId)

    // Remove the lastLogoutTimestamp key from localStorage after a short delay
    // to ensure the logout process is completed
    setTimeout(() => localStorage.removeItem(LAST_LOGOUT_TIMESTAMP_KEY), 100)
  }

  return handleLogout
}
